import SG from 'ml-savitzky-golay-generalized';
import { optimize } from 'ml-spectra-fitting';
import { xFindClosestIndex } from 'ml-spectra-processing';
export function joinBroadPeaks(data, peakList, options = {}) {
    let { broadMask, shape = { kind: 'gaussian' }, optimization = { kind: 'lm', options: { timeout: 10 } }, sgOptions = {
        windowSize: 9,
        polynomial: 3,
    }, broadRatio = 0.0025, broadWidth = 0.25, } = options;
    let max = 0;
    let maxI = 0;
    let count = 1;
    const broadLines = [];
    const peaks = JSON.parse(JSON.stringify(peakList));
    const mask = !broadMask
        ? getSoftMask(data, peaks, { sgOptions, broadRatio })
        : broadMask;
    if (mask.length !== peaks.length) {
        throw new Error('mask length does not match the length of peaksList');
    }
    for (let i = peaks.length - 1; i >= 0; i--) {
        if (mask[i]) {
            broadLines.push(peaks.splice(i, 1)[0]);
        }
    }
    // Push a feke peak
    broadLines.push({ x: Number.MAX_VALUE, y: 0, width: 0 });
    let candidates = {
        x: [broadLines[0].x],
        y: [broadLines[0].y],
    };
    let indexes = [0];
    for (let i = 1; i < broadLines.length; i++) {
        if (Math.abs(broadLines[i - 1].x - broadLines[i].x) < broadWidth) {
            candidates.x.push(broadLines[i].x);
            candidates.y.push(broadLines[i].y);
            if (broadLines[i].y > max) {
                max = broadLines[i].y;
                maxI = i;
            }
            indexes.push(i);
            count++;
        }
        else {
            if (count > 2) {
                let fitted = optimize(candidates, [
                    {
                        x: broadLines[maxI].x,
                        y: max,
                        width: candidates.x[0] - candidates.x[candidates.x.length - 1],
                        shape,
                    },
                ], { shape, optimization });
                let { peaks: peak } = fitted;
                peaks.push(peak[0]);
            }
            else {
                // Put back the candidates to the signals list
                indexes.forEach((index) => {
                    peaks.push(broadLines[index]);
                });
            }
            candidates = { x: [broadLines[i].x], y: [broadLines[i].y] };
            indexes = [i];
            max = broadLines[i].y;
            maxI = i;
            count = 1;
        }
    }
    peaks.sort((a, b) => {
        return a.x - b.x;
    });
    return peaks;
}
function getSoftMask(data, peakList, options) {
    const { sgOptions, broadRatio } = options;
    const { windowSize, polynomial } = sgOptions;
    const yData = new Float64Array(data.y);
    const xData = new Float64Array(data.x);
    if (xData[1] - xData[0] < 0) {
        yData.reverse();
        xData.reverse();
    }
    const ddY = SG(yData, xData[1] - xData[0], {
        windowSize,
        polynomial,
        derivative: 2,
    });
    let maxDdy = 0;
    for (const ddYIndex of ddY) {
        if (Math.abs(ddYIndex) > maxDdy)
            maxDdy = Math.abs(ddYIndex);
    }
    const broadMask = [];
    for (let peak of peakList) {
        const { x: xValue } = peak;
        const index = xFindClosestIndex(xData, xValue, { sorted: true });
        broadMask.push(Math.abs(ddY[index]) <= broadRatio * maxDdy);
    }
    return broadMask;
}
//# sourceMappingURL=joinBroadPeaks.js.map